
export default {
  name: "ExtraMenuElement",

  data: function () {
    return {
      isOpen: false
    }
  },

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    children: function () {
      return (this.item?.children || []).filter((t) => !Boolean(t.isHidden))
    }
  },

  components: {
    DropDownLevel: () => import("./_DropDownLevel.vue")
  },

  methods: {
    openDropdown: function () {
      this.isOpen = true;
    },
    closeDropdown: function () {
      this.isOpen = false;

      this.$refs.refExtraMenuElement.style.pointerEvents = "none";
      setTimeout(() => {
        this.$refs.refExtraMenuElement.style = "";
      }, 500);
    },
  }
}
